const INITIAL_STATE = {
  errors: {},
  list: {},
  addResource: {},
  editResource: {},
  deleteResource: {}
}

const resource = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_RESOURCE_LIST':
    return { ...state, ...INITIAL_STATE, list: action.data }
  case 'GET_RESOURCE_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_RESOURCE':
    return { ...state, ...INITIAL_STATE, addResource: action.data }
  case 'ADD_RESOURCE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_RESOURCE':
    return { ...state, ...INITIAL_STATE, editResource: action.data }
  case 'UPDATE_RESOURCE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_RESOURCE':
    return { ...state, ...INITIAL_STATE, deleteResource: action.data }
  case 'DELETE_RESOURCE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default resource;
